import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { FiRefreshCw } from "react-icons/fi";
import { AiOutlineUser } from "react-icons/ai";
import { MdSchool } from "react-icons/md";
import { BsFillPersonFill } from "react-icons/bs";

function ResetPassword() {
const [users, setUsers] = useState([]);
const [loading, setLoading] = useState(true);

const [search, setSearch] = useState("");
const [filterType, setFilterType] = useState("all");

const [sortField, setSortField] = useState("username");
const [sortAsc, setSortAsc] = useState(true);
const [pageInput, setPageInput] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const pageSize = 5;

const [modalOpen, setModalOpen] = useState(false);
const [username, setUsername] = useState("");
const [newPassword, setNewPassword] = useState("");
const [message, setMessage] = useState("");

const currentSession = localStorage.getItem("currentSessionId");
const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/users`;
const token = localStorage.getItem("token");

const toggleSort = (field) => {
if (sortField === field) {
setSortAsc(!sortAsc);
} else {
setSortField(field);
setSortAsc(true);
}
};
const handlePageJump = () => {
  const page = Number(pageInput);

  if (!page || page < 1 || page > totalPages) {
    return;
  }

  setCurrentPage(page);
  setPageInput("");
};
const filteredUsers = useMemo(() => {
  let data = [...users];

  if (search.trim()) {
    const query = search.toLowerCase();

    data = data.filter((u) => {
      return (
        u.username.toLowerCase().includes(query) ||
        u.usertype.toLowerCase().includes(query)
      );
    });
  }

  if (filterType !== "all") {
    data = data.filter((u) => u.usertype === filterType);
  }

  data.sort((a, b) => {
    const x = a[sortField]?.toString().toLowerCase();
    const y = b[sortField]?.toString().toLowerCase();
    return sortAsc ? x.localeCompare(y) : y.localeCompare(x);
  });

  return data;
}, [users, search, filterType, sortField, sortAsc]);

const totalPages = Math.ceil(filteredUsers.length / pageSize);

const paginatedUsers = filteredUsers.slice(
(currentPage - 1) * pageSize,
currentPage * pageSize
);

useEffect(() => {
const fetchUsers = async () => {
try {
const res = await axios.get(`${API_BASE}/all`, {
headers: { Authorization: `Bearer ${token}` },
params: { sessionId: currentSession },
});


    setUsers(res.data);
  } catch (err) {
    console.error(err);
  }
  setLoading(false);
};

fetchUsers();


}, [token, currentSession]);

const handleResetClick = (user) => {
setUsername(user.username);
setNewPassword("");
setMessage("");
setModalOpen(true);
};

const changePassword = async () => {
if (!newPassword.trim()) {
setMessage("Password cannot be empty");
return;
}

try {
  const res = await axios.post(
    `${API_BASE}/admin-reset-password`,
    { username, newPassword },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  if (res.data.success) {
    setMessage("Password updated successfully!");
    setTimeout(() => setModalOpen(false), 1000);
  } else {
    setMessage(res.data.message || "Error updating password");
  }
} catch (err) {
  console.error(err);
  setMessage("Error updating password");
}

};

return ( <div className="p-6">
  <div className="mb-4 flex justify-between items-center">
  <input
    type="text"
    placeholder="Search by username..."
    className="border p-2 rounded w-1/3"
    value={search}
    onChange={(e) => {
      setSearch(e.target.value);
      setCurrentPage(1); // reset to first page on search
    }}
  />

  <select
    className="border p-2 rounded"
    value={filterType}
    onChange={(e) => {
      setFilterType(e.target.value);
      setCurrentPage(1);
    }}
  >
    <option value="all">All</option>
    <option value="student">Student</option>
    <option value="teacher">Teacher</option>
  </select>
</div>
 <div className="overflow-x-auto shadow-md rounded-lg bg-white"> <table className="min-w-full table-auto"> <thead> <tr className="bg-blue-600 text-white">
<th
className="p-4 cursor-pointer text-left"
onClick={() => toggleSort("username")}
>
Username {sortField === "username" && (sortAsc ? "▲" : "▼")} </th>

          <th
            className="p-4 cursor-pointer text-left"
            onClick={() => toggleSort("usertype")}
          >
            User Type {sortField === "usertype" && (sortAsc ? "▲" : "▼")}
          </th>

          <th className="p-4 text-center">Action</th>
        </tr>
      </thead>

      <tbody>
        {!loading &&
          paginatedUsers.map((user) => (
            <tr key={user._id} className="hover:bg-gray-50 border-b">
              <td className="p-4">
                <div className="flex items-center gap-3">
                  <AiOutlineUser className="text-blue-500 text-xl" />
                  <span>{user.username}</span>
                </div>
              </td>

              <td className="p-4">
                <div className="flex items-center gap-3">
                  {user.usertype === "student" ? (
                    <>
                      <MdSchool className="text-green-500 text-xl" />
                      <span>Student</span>
                    </>
                  ) : (
                    <>
                      <BsFillPersonFill className="text-purple-500 text-xl" />
                      <span>Teacher</span>
                    </>
                  )}
                </div>
              </td>

              <td className="p-4 text-center">
                <button
                  className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded flex items-center gap-2 justify-center"
                  onClick={() => handleResetClick(user)}
                >
                  <FiRefreshCw /> Reset
                </button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
<div className="flex justify-between items-center p-4 flex-wrap gap-3">
  {/* Prev */}
  <button
    disabled={currentPage === 1}
    className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
    onClick={() => setCurrentPage((p) => p - 1)}
  >
    Prev
  </button>

  {/* Page Info */}
  <span>
    Page {currentPage} of {totalPages}
  </span>

  {/* Next */}
  <button
    disabled={currentPage === totalPages}
    className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
    onClick={() => setCurrentPage((p) => p + 1)}
  >
    Next
  </button>

  {/* Jump to page */}
  <div className="flex items-center gap-2">
    <input
      type="number"
      min="1"
      max={totalPages}
      placeholder="Go to..."
      className="border p-1 rounded w-20"
      value={pageInput}
      onChange={(e) => setPageInput(e.target.value)}
    />

    <button
      onClick={handlePageJump}
      className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
    >
      Go
    </button>
  </div>
</div>
  </div>

  {modalOpen && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">
          Reset Password for {username}
        </h2>

        {message && (
          <p className="mb-4 text-center text-sm text-red-600">
            {message}
          </p>
        )}

        <input
          type="password"
          placeholder="Enter New Password"
          className="border p-2 rounded w-full mb-4"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <button
          onClick={changePassword}
          className="bg-purple-500 text-white px-4 py-2 rounded w-full hover:bg-purple-600"
        >
          Update Password
        </button>

        <button
          className="mt-4 text-gray-500 underline w-full"
          onClick={() => setModalOpen(false)}
        >
          Close
        </button>
      </div>
    </div>
  )}
</div>


);
}

export default ResetPassword;
